import React, { useState, useEffect } from 'react'

const createUserObj = user => {
    if (!user) return null
    const { profile } = user
    if (!profile) return null
    const accessKey = profile.TADAAccessKey
    const userInfo = JSON.parse(profile.TADAUserDetails)
    const { FirstName, LastName, ScreenAlias, UserId, Email, Phone, Preferences, Permissions, IsCoreSuperUser } =
        userInfo

    return {
        accessKey,
        firstName: FirstName,
        lastName: LastName,
        username: ScreenAlias,
        isCoreSuperUser: IsCoreSuperUser,
        userId: UserId,
        email: Email || '',
        phone: Phone || '',
        preferences: Preferences,
        permissions: Permissions,
        userInfo,
    }
}

const AuthContext = React.createContext()

const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null)
    const [loading, setLoading] = useState(true)
    const [oUser, setOUser] = useState(null)
    const [actAs, setActAs] = useState(null)

    useEffect(() => {
        setLoading(true)
        if (oUser) {
            setUser(createUserObj(oUser))
            setLoading(false)
        } else setLoading(false)
    }, [oUser])

    if (loading) return null
    return <AuthContext.Provider value={{ user, setOUser, actAs, setActAs }}>{children}</AuthContext.Provider>
}

const AuthConsumer = AuthContext.Consumer

export { AuthContext, AuthProvider, AuthConsumer }
